export default "__VITE_ASSET__ChKlbWee__"